import React from "react";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Hero from "./components/Hero";
import Summary from "./components/SummarySection";
import OverviewSection from "./components/OverviewSection";
import TimelineSection from "./components/TimelineSection";
import FuturePlansSection from "./components/FuturePlansSection";
import SkillsSection from "./components/SkillsSection";
import LanguagesSection from "./components/LanguagesSection";
import HobbiesSection from "./components/HobbiesSection";
import ProjectsSection from "./components/ProjectsSection";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Flashcards from "./pages/Flashcards";
import WiringDiagrams from "./pages/WiringDiagrams";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/wiring-diagrams" element={<WiringDiagrams />} />
        <Route
          path="*"
          element={
            <div className="app-container">
              <Header />
              <div className="content-wrapper">
                <Sidebar />
                <div className="main-content">
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <>
                          <Hero />
                          <Summary />
                          <OverviewSection />
                          <TimelineSection />
                          <ProjectsSection />
                          <FuturePlansSection />
                          <SkillsSection />
                          <LanguagesSection />
                          <HobbiesSection />
                        </>
                      }
                    />
                    <Route path="/flashcards" element={<Flashcards />} />
                  </Routes>
                </div>
              </div>
              <ScrollToTop />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;